import styled from 'styled-components';
import { DESKTOP_MEDIA_QUERY, MOBILE_MEDIA_QUERY } from '~/constants';

type IsModalVisibleProps = {
  readonly visible: boolean;
};

export const OverlayMenuWrapper = styled.div<IsModalVisibleProps>`
  display: ${(prop) => (prop.visible ? 'block' : 'none')};
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 100;

  ${DESKTOP_MEDIA_QUERY} {
    background-color: rgba(5, 8, 37, 0.88);
  }

  ${MOBILE_MEDIA_QUERY} {
    background-color: rgba(5, 8, 37, 0.85);
  }
`;

export const OverlayHeaderWrapper = styled.header`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${DESKTOP_MEDIA_QUERY} {
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
  }

  ${MOBILE_MEDIA_QUERY} {
    padding-top: 20px;
    padding-left: 15px;
    padding-right: 20px;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${DESKTOP_MEDIA_QUERY} {
    width: 180px;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 86.5px;
  }
`;

export const CloseButton = styled.button`
  box-sizing: content-box;
  border: none;
  padding: 0;
  cursor: pointer;

  ${DESKTOP_MEDIA_QUERY} {
    width: 50px;
    height: 50px;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 25px;
    height: 25px;
  }
`;

export const CloseButtonIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const RerootsLogo = styled.div`
  ${DESKTOP_MEDIA_QUERY} {
    width: 115px;
    height: 31px;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 57.5px;
    height: 15.5px;
  }
`;

export const RerootsLogoIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const Contact = styled.div`
  border: solid 1px rgb(5, 8, 37);
  background-color: #ff9000;
  display: flex;
  align-items: center;
  justify-content: center;

  ${DESKTOP_MEDIA_QUERY} {
    width: 9.03vw;
    height: 3.47vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 17.33vw;
    height: 6.67vw;
  }
`;

export const ContactText = styled.p`
  font-weight: 700;
  line-height: 2.81;
  letter-spacing: 0.1em;
  text-align: center;
  color: #050825;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 0.78vw;
  }

  ${MOBILE_MEDIA_QUERY} {
    font-size: 1.6vw;
  }
`;

export const MenuContainer = styled.div`
  width: 100%;
  text-align: center;

  ${DESKTOP_MEDIA_QUERY} {
    padding-top: 6.46%;
  }

  ${MOBILE_MEDIA_QUERY} {
    padding-top: 33.7%;
  }
`;

export const MenuItemBox = styled.div`
  margin: 0 auto;

  ${DESKTOP_MEDIA_QUERY} {
    width: 35%;
    font-size: 2.08vw;
    padding-bottom: 1.5em;
  }

  ${MOBILE_MEDIA_QUERY} {
    width: 66.66%;
    font-size: 4vw;
    padding-bottom: 3em;
  }
`;

export const MenuItem = styled.p`
  font-size: 1em;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #ffffff;
`;
